import { useTranslation } from "react-i18next";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Timeline } from "primereact/timeline";
import { DefectActivity } from "../../types/DefectActivity";
import dayjs from "dayjs";
import "./DefectRectificationActivity.css";

type DefectRectificationActivityProps = {
    className?: string;
    activityData: DefectActivity[];
    activityLoading: boolean;
    activityError: boolean;
}

export const DefectRectificationActivity = (props: DefectRectificationActivityProps) => {
    const { className, activityData, activityError, activityLoading } = props;

    const { t } = useTranslation("locale");

    const formatDate = (dateString: string) => {
        let formattedDate = "";

        if (dateString) {
            if (Number.isNaN(Number(dateString))) {
                formattedDate = `${dateString} 00:00 - `;
            } else {
                formattedDate = `${dayjs(Number(dateString) * 1000).format("DD/MM/YYYY HH:mm")} - `
            }
        }
      
        return formattedDate;
    }

    const itemTemplate = (item: DefectActivity) => {
        if (item.defectComment) {
            return commentItemTemplate(item);
        }

        return (
            <span className="defect-rectification-activity-text">{formatDate(item.createdAt)}
                <span className={item.createdAt ? "defect-rectification-activity-subtext" : "defect-rectification-activity-text"}>{item.activity}</span>
            </span>
        )
    };

    const commentItemTemplate = (item: DefectActivity) => (
        <span className="defect-rectification-activity-text">{formatDate(item.createdAt)}
            <span className={item.createdAt ? "defect-rectification-activity-subtext" : "defect-rectification-activity-text"}>{item.activity}</span>
            <div className="defect-rectification-activity-comment-container">
                <span className="defect-rectification-activity-comment">{item.defectComment}</span>
            </div>
        </span>
    );

    const markerTemplate = (item: DefectActivity) => (
        <div className={item.createdAt ? "defect-rectification-activity-marker" : "p-timeline-event-marker"} />
    );

    let content = <Timeline className="defect-rectification-activity" value={activityData} content={itemTemplate} marker={markerTemplate} />;

    if (activityLoading) {
        content = <ProgressSpinner className="flex align-self-center" />;
    }

    if (activityError) {
        content = <p>{t("defectRectification.getActivityError")}</p>;
    }

    return (
        <Card
            header={
                <h2
                    style={{
                        border: "none",
                        marginLeft: "0",
                        whiteSpace: "nowrap"
                    }}
                >
                    {t("defectRectification.activityTimeline")}
                </h2>
            }
            className={className}
        >
            {content}
        </Card>
    );
};
